import { gql } from "@apollo/client";

export const setWsPayResponse = gql`mutation SetWsPayResponse($id: String!, $input: WsPayResponseInput!) {
  setWsPayResponse(id: $id, input: $input)  
}
`;